// @flow
import React from 'react';
import { EVENT_LISTENER_FILL_COLOR, ICON_FILL_COLOR } from '../constants/Style';

type LabelProps = {
  labelText: string
};
export const LABEL_HEIGHT = 30;
export const LABEL_WIDTH = 80;
export const LABEL_RADIUS_X = 15;
export const LABEL_RADIUS_Y = 30;
export const LABEL_FILL = EVENT_LISTENER_FILL_COLOR;

export const LabelNode = (props: LabelProps) => (
  <text
    x="39"
    y="19"
    textAnchor="middle"
    fill={ICON_FILL_COLOR}
    style={{
      fontSize: '14px'
    }}
  >
    {props.labelText}
  </text>
);



// WEBPACK FOOTER //
// ./src/components/LabelNode.jsx